import otpPanel from "./otpPanel.container";

export default otpPanel;